
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4690_3238)"}},[_c('path',{attrs:{"d":"M12.46 5.81a5.94 5.94 0 00-.77-1.82l.7-1.47-.98-.98-1.47.7a5.4 5.4 0 00-1.75-.7L7.7 0H6.3l-.56 1.54c-.63.14-1.19.42-1.75.77l-1.47-.7-.98.91.7 1.47a5.4 5.4 0 00-.7 1.75L0 6.3v1.4l1.54.56c.14.63.42 1.26.7 1.75l-.7 1.47.98.98 1.47-.7c.56.35 1.12.63 1.75.77L6.3 14h1.4l.56-1.54c.21-.07.49-.14.7-.21l-1.12-1.12C5.18 11.62 2.8 9.66 2.8 7c0-2.31 1.89-4.2 4.2-4.2 2.59 0 4.55 2.31 4.13 4.76l1.19 1.19c.07-.21.14-.35.14-.56L14 7.7V6.3l-1.54-.49z"}}),_c('path',{attrs:{"d":"M13.496 12.085l-4.13-4.13c.98-2.17-1.05-4.48-3.29-3.85l1.26 1.26c.56.56.56 1.47 0 1.96-.49.56-1.47.56-1.96 0l-1.26-1.19c-.63 1.96 1.4 4.2 3.71 3.29l4.13 4.13c.42.42 1.05.42 1.47 0 .42-.35.42-1.05.07-1.47z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4690_3238"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    